/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import ReactDOM from 'react-dom';
import React from 'react';
import 'promise-polyfill';
// eslint-disable-next-line
import registerServiceWorker from 'Utils/pwa';
import initStore from 'App/initStore';
import BinarySocket from '_common/base/socket_base';
import App from 'App/app.jsx';
import {
    applyOAuth2AuthFromQuery,
    checkAndSetEndpointFromUrl,
    isEmbeddedPuIframe,
} from '@deriv/shared';
import { processAuthTokensFromUrl, checkLogoutParam } from '@deriv/utils';
import AppNotificationMessages from './App/Containers/app-notification-messages.jsx';
import { AnalyticsInitializer } from 'Utils/Analytics';

AnalyticsInitializer();
if (
    !!window?.localStorage.getItem?.('debug_service_worker') || // To enable local service worker related development
    (!window.location.hostname.startsWith('localhost') && !/binary\.sx/.test(window.location.hostname)) ||
    window.location.hostname === 'deriv-app.binary.sx'
) {
    registerServiceWorker();
}

const has_endpoint_url = checkAndSetEndpointFromUrl();

// if has endpoint url, APP will be redirected
if (!has_endpoint_url) {
    const initApp = async () => {
        const queryParams = new URLSearchParams(window.location.search || '');

        // Query auth is the ONLY session channel (no cookies, no postMessage bridge):
        // the parent site loads this app with `?token=…&account_id=…&client_id=…`.
        const is_embedded_app =
            queryParams.get('bridge') === 'postmessage' ||
            (typeof window !== 'undefined' && window.parent !== window);

        const shouldLogout = checkLogoutParam();

        /*
         * Parent-driven session handoff: the embedding site passes `?token=…&account_id=…&client_id=…`.
         * This must run BEFORE `initStore` so the stores and the OTP WebSocket boot from a fully
         * hydrated localStorage. The session is persisted and the token stripped from the URL inside
         * the call (see `applyOAuth2AuthFromQuery`).
         */
        const oauth2_query_auth_applied = !shouldLogout && (await applyOAuth2AuthFromQuery());

        // Legacy `acct1/token1` URL bootstrap (top-level flows only; never in an iframe, and never when
        // the parent query handoff was applied).
        if (!oauth2_query_auth_applied && !is_embedded_app && !shouldLogout && !isEmbeddedPuIframe()) {
            processAuthTokensFromUrl();
        }

        const root_store = initStore(AppNotificationMessages);

        /*
         * Gate the first render on the socket transport existing. `initStore` starts the connection
         * without awaiting it; an OAuth2 boot first POSTs for an OTP WebSocket URL (async REST), so
         * `deriv_api` does not exist during that window. Store mounts that run on the first render
         * (`portfolio.onMount`, active symbols, cashier lists) call socket methods immediately — in
         * production the minified bundle renders fast enough to always outrun the OTP fetch, and
         * those calls crashed (`WS.portfolio is not a function` / `deriv_api` undefined) leaving the
         * app stuck on the loading screen. Anonymous sessions construct `deriv_api` synchronously,
         * so this resolves immediately for them (`socket_base.whenConnectionReady`).
         */
        try {
            await BinarySocket.whenConnectionReady?.();
        } catch {
            /* never block boot on the readiness gate */
        }

        const wrapper = document.getElementById('deriv_app');
        if (wrapper) {
            ReactDOM.render(<App useSuspense={false} root_store={root_store} />, wrapper);
        }

        if (!is_embedded_app && shouldLogout) {
            root_store.client
                .logout()
                .catch(error => {
                    console.error('[dtrader-c][index] Error processing logout query:', error);
                });
        }
    };

    void initApp();
}
